// extracted by mini-css-extract-plugin
export default {"primary-selected":"tab__primary-selected___pmAcz","primary":"tab__primary___2Zp1h","secondary-selected":"tab__secondary-selected___80ycx","secondary":"tab__secondary___2h5tv"};